import React from 'react';
import { Card, Container } from 'react-bootstrap';

const About = () => {
    return (
        <Container className="mt-5">
            <Card className="text-center">
                <Card.Header>About Us</Card.Header>
                <Card.Body>
                    <Card.Text>This is an about page where you can learn more about our application.</Card.Text>
                </Card.Body>
            </Card>
        </Container>
    );
};

export default About;
